let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9eM0F")).then(() => parcelRequire('52WYW'));